import { encodeCountryTaxType } from '../../../utils/encodeDecodeCTT';
import { formatValue, NumeralTypes } from '../../../shared/numeral.component';

const formatTaxRate = taxRate => formatValue({ value: taxRate, type: NumeralTypes.PERCENT_4 });

const mapCountryTaxTypes = countryTaxTypes => countryTaxTypes
  .map(({ countryTaxType, description, countryCode, taxRate }) => ({
    label: encodeCountryTaxType(countryCode, countryTaxType),
    value: countryTaxType,
    taxRate: formatTaxRate(taxRate),
    description,
    tooltip: `${description} - ${formatTaxRate(taxRate)}`,
  }));

export default mapCountryTaxTypes;
